module.exports = __webpack_public_path__ + "img/bqtx.dc43b71b.svg";